import create from "zustand";
import { TableRowTalhoes } from "../interfaces/TableRow";

interface TableState {
  idSelecao: string;
  rows: TableRowTalhoes[];

  setIdSelecao: (id: string) => void;
  addRow: (row: TableRowTalhoes[]) => void;
  updateRow: (index: number, updated: Partial<TableRowTalhoes>) => void;
  removeRow: (index: number) => void;
  clearRows: () => void;
  
}

export const useTableListTalhoes = create<TableState>((set, get) => ({
  idSelecao: '',
  rows: [],
  rowsCopy: [],

  setIdSelecao: (idSelecao) => {
    set(state => ({ idSelecao }));
  },

  addRow: (newRow) =>
  set((state) => {

    const newRows = [...state.rows, ...newRow ];

    return { rows: newRows };
  }),

  updateRow: (index, updated) =>
  set((state) => {
    if (index < 0 || index >= state.rows.length) return { rows: state.rows };

    const updatedRows = [...state.rows];
    const current = updatedRows[index];
    const merged = { ...current, ...updated };


    updatedRows[index] = merged;

    const newRows = [...updatedRows];

    return { rows: newRows };
  }),


  removeRow: (index) =>
  set((state) => ({
    rows: state.rows.filter((_, i) => i !== index),
  })),

  clearRows: () => set({ rows: [] }),
}));